<template>
  <div class="bookings">
    <page-header title="Dispatch Management" :back="{ path: '/operations/dispatch/' }"
      breadcrumb="Dashboard > Bookings & Shipments > Dispatch Management" />

    <div class="business-status pt-4">
      <div class="">
        <div class="flex  justify-between items-center mb-8 pl-2">
          <div class="box-cover  flex items-center">
            <div :class="['color-box', { 'active': selected === 'Yes' }]" @click="selectOption('Yes')"></div>
            <p class="ml-2 text-[64px] font-bold text-[#383F51]">Long Haul</p>
          </div>
          <div class="box-cover  flex items-center">
            <div :class="['color-box', { 'active': selected === 'No' }]" @click="selectOption('No')"></div>
            <p class="ml-2 text-[14px] font-bold text-rose-500">Last Mile Shipment</p>
          </div>
        </div>

        <div v-if="selected === 'Yes'">
          <Yes :openShippingLabelAction="openShippingLabelAction" @setSelecetedDIspatch="setSelecetedDIspatch"
            @setSelecetedDetailDispatch="setSelecetedDetailDIspatch" />
        </div>

        <div v-if="selected === 'No'">
          <No :openDispatchSummaryAction="openDispatchSummaryAction" @setSelecetedLastMileDDispatch="setSelecetedLastMileDDispatch"
            @setSelecetedDetailDispatch="setSelecetedDetailDIspatch"/>
        </div>
      </div>

    </div>

    <!-- <h2 class="text-lg font-semibold my-12">Select Shipments</h2> -->

    <!-- <div class="flex items-center justify-between" style="height: 40px">
      <div class="h-full flex items-center">
        <el-dropdown>
          <button class="sort-button flex items-center justify-center rounded-md h-full mr-3"
            style="width: 40px; height: 40px; background-color: #f7fafd">
            <sort-icon />
          </button>
          <el-dropdown-menu slot="dropdown" placement="right-end">
            <el-dropdown-item disabled>SORT BY</el-dropdown-item>

            <el-dropdown-item>
              <button @click="sortOrder = 'ASC'" class="flex items-center">
                <span class="ml-2">ASC</span>
              </button>
            </el-dropdown-item>
            <el-dropdown-item>
              <button @click="sortOrder = 'DESC'" class="flex items-center">
                <span class="ml-2">DESC</span>
              </button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <div class="flex items-center mr-12">
          <el-select v-model="selectedShippingServiceId" placeholder="Select service route" @change="getAllBookings"
            style="margin: 0">
            <el-option label="all" :value="null" />
            <el-option v-for="shippingservice in locationBasedRoutes" :key="shippingservice.id"
              :label="shippingservice.routeName" :value="shippingservice.id">
            </el-option>
          </el-select>
        </div>

        <div hidden class="date-picker flex items-center justify-center">
          <el-date-picker type="date" placeholder="Start Date" style="margin: 0" class="mr-3" v-model="startDate" />

          <el-date-picker type="date" placeholder="End Date" style="margin: 0" v-model="endDate" />
        </div>
      </div>

      <el-dropdown class="h-full" v-if="payload && payload.shipments && payload.shipments.length">
        <button class="table-assign bg-charcoal text-white h-full rounded flex items-center px-3">
          <span class="border-r border-white mr-3 pr-2">Assign to Fleet</span>

          <arrow-down-filled />
        </button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <button @click="
              showConsolidationDialog = true;
            newBooking = false;
            ">
              Assign to Fleet
            </button>
          </el-dropdown-item>

          <el-dropdown-item>
            <button @click="
              newBooking = true;
            createConsolidation({ status: 'on-hold' });
            ">
              Create a New Booking
            </button>
          </el-dropdown-item>

          <el-dropdown-item>
            <button @click="
              newBooking = false;
            createConsolidation({ status: 'on-hold' });
            ">
              Keep On-Hold
            </button>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div> -->



    <!-- <div class="py-5 bg-white w-100" v-if="isFetchingBookings">
      <loader />
    </div>

    <div v-if="!filteredBookings && !filteredBookings.length && !isFetchingBookings"
      class="bg-white w-100 flex justify-center flex-col items-center p-5">
      <empty-table-icon />
      <p class="font-semibold pt-3 pb-5">No Items found!</p>
    </div> -->

    <!-- <div class="mt-3">
      <pagination-control :total="totalBookings" :pageNumber="pageNumber" @pageSize="pageSize = $event"
        @pageNumber="pageNumber = $event" />
    </div> -->

    <!--========= modals =========-->
    <!-- <el-dialog :visible.sync="showConsolidationDialog" width="60%"> -->
    <!-- <div class="flex items-start justify-between mb-4"> -->
    <!-- <div>
          <h2 class="text-2xl font-semibold">Consolidation ID#</h2>
          <div>457906-04</div>
        </div> -->

    <!-- <div>
          <h3 class="text-lg font-semibold">Est. Consolidated cap. (Tonnes)</h3>
          <div>{{ fleetDetails.carriageCapacity }} Tons</div>
        </div> -->
    <!-- </div> -->
    <!-- {{ filterUndispatchedFleet  }} -->
    <!-- <div class="flex flex-wrap justify-between"> -->
    <!-- <div class="flex flex-wrap w-full justify-between"> -->
    <!-- <div class="places_wrapper mb-4" style="border: 1px solid #dae8f6; height: 200px">
            <div class="pl-4 flex items-center font-semibold" style="background: #ecf3fb; height: 60px">
              Origin
            </div>

            <div class="px-4 mt-4">
              {{
                currentLocation
                  ? currentLocation.location.locationName
                  : "No Location Selected"
              }},
              <br />
              {{ currentLocation ? currentLocation.location.address : "" }}
            </div>
          </div> -->

    <!-- <div class="mb-4 places_wrapper" style="border: 1px solid #dae8f6; height: 200px">
            <div class="pl-4 flex items-center font-semibold" style="background: #cef1e8; height: 60px">
              Destination
            </div>

            <div class="px-4 mt-4">
              <label class="mb-1">Destination</label>

              <el-select v-model="payload.destination" placeholder="Select Destinations">
                <el-option v-for="location in locations" :key="location.id" :label="location.locationName"
                  :value="location.id">
                </el-option>
              </el-select>
            </div>
          </div> -->
    <!-- </div> -->

    <!-- <div class="w-full flex flex-wrap justify-between">
          <div class="w-full md:w-6/12">
            <label class="mb-1">Vehicle Type/ Carrying Capacity</label>
            <div class="w-full flex items-center gap-3">
              <el-select v-model="payload.vehicleType" placeholder="Select vehicle type">
                <el-option v-for="vehicleType in fleetForConsolidation" :key="vehicleType.type"
                  :label="vehicleType.type" :value="vehicleType.type">
                </el-option>
              </el-select>

              <el-select v-model="fleetCapacity" placeholder="Select fleet">
                <el-option v-for="fleet in filterFleetByType" :key="fleet.capacity" :label="fleet.capacity"
                  :value="fleet.capacity">
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="w-full md:w-5/12">
            <label class="mb-1">Plate Number</label>
            <el-select v-model="payload.fleetId" placeholder="Select fleet">
              <el-option v-for="fleet in filterFleetByTypeTonnage" :key="fleet.vehicleNumber"
                :label="fleet.vehicleNumber" :value="fleet.id">
              </el-option>
            </el-select>
            <p class="driver_details">
              Driver: {{ driverName }}
            </p>
          </div>
        </div> -->

    <!-- <div class="mt-5 w-full md:w-6/12">
          <label>Upload Documents</label>
          <div :style="{
            'background-color': '#FBFCFE',
            border: '1px solid #DAE8F6',
          }" class="pt-2 px-3 rounded-lg overflow-hidden flex justify-between pb-2 w-full">
            <div :style="{ color: '#B7BDCD', fontSize: '16px' }" class="mt-1 w-9/12">
              <p v-if="!isUploadingDoc && !docUploaded">Upload File</p>
              <div v-if="isUploadingDoc" class="d-flex justify-content-center py-2 -mt-2">
                <saving-loader :icon-color="'#0253B3'" />
              </div>
            </div>

            <button @click="triggerUpload = true" :style="{
              'background-color': '#CBE0F6',
              height: '32px',
              width: '91px',
            }" class="rounded-lg w-3/12">
              Upload
            </button>
          </div>

          <div class="mt-3">
            <div class="image_list" v-for="url in payload.documentUrl" :key="url">{{ url.substring(url.length - 20)
            }}<button @click="removeImageUrl(url)">&#x2715;</button>
            </div>
          </div>

          <document-upload hidden ref="documentUploader" @input="handleDocUpload($event)"
            @closeTrigger="triggerUpload = false" @remove-image="removeImage" :docurl="docurl"
            :triggerUpload="triggerUpload" :isUploadingImage="isUploadingDoc" />
        </div> -->

    <!-- <div class="mt-5">
          <div class="flex flex-no-wrap justify-between gap-2">
            <p>Truck Capacity {{ " " }} </p>
            <p v-if="fleetDetails != 'N.A'">
              {{ calculateCapacity }}/{{ Number(fleetDetails.carriageCapacity) }} Tons
            </p>
          </div>
          <div class="flex flex-row-reverse h-[17px] mt-4">
            <div :style="{ 'background-color': '#D5F2EA' }" class="w-100 relative z-20 h-6 rounded-r-lg"
              v-if="(calculateCapacity / Number(fleetDetails.carriageCapacity)) * 100 < 100"></div>
            <div :style="{
              'background-color': '#00C48C',
              width:
                fleetDetails != 'N.A'
                  ? (calculateCapacity / Number(fleetDetails.carriageCapacity)) *
                  100 +
                  '%'
                  : '0%',
            }" class="h-6 relative z-10 rounded-l-lg"></div>
          </div>
        </div> -->
    <!-- </div> -->

    <!-- <div class="flex justify-between mt-5" style="height: 40px">
        <button class="h-full bg-charcoal text-white rounded font-semibold" style="width: 120px"
          @click="createConsolidation('consolidation-completed')">
          Complete
        </button>

        <div class="h-full">
          <button class="h-full font-semibold" style="width: 120px" @click="showConsolidationDialog = false">
            Cancel
          </button>

          <primary-button class="h-full bg-primary-yellow rounded font-semibold" buttonText="Save" style="width: 120px"
            :loading="isLoading" :disabled="!canSave" @click="createConsolidation('in-progress')" />

        </div>
      </div> -->
    <!-- </el-dialog> -->
    <!-- <edit-booking-modal :show-modal="showEditBookingModal" :booking="selectedBooking"
      @close-modal="showEditBookingModal = false" />
    <confirm-cancel-modal :show-modal="showCancelModal" @booking-subaction-completed="actionCompleted"
      :booking="selectedBooking" @close-modal="showCancelModal = false" @show-cancel-modal="
        showCancelModal = false;
      showFinCancelModal = true;
      " />
    <cancel-modal @booking-subaction-completed="actionCompleted" :show-modal="showFinCancelModal"
      @close-modal="showFinCancelModal = false" :booking="selectedBooking" /> -->

    <!-- <ShippingLabel @open-dispatch-modal="openDispatchModal" :show-modal="showShippinLabel" @close-modal="showShippinLabel = false" :selcetdDispatchDetail="selcetdDispatchDetail"/> -->
    <ShippingLabel @create-dispatch="createDispatch" @open-dispatch-modal="openDispatchModal"
      :show-modal="showShippinLabel" @close-modal="showShippinLabel = false"
      :selcetdDispatchDetail="selcetdDispatchDetail" :selecetedDispatch="selecetedDispatch"
      :longHaulDispatchables="longHaulDispatchables" @open-update-status-modal="updateStatus" />


    <DispatchModal @go-back="goBack" :selecetedDispatch="selecetedDispatch" :show-modal="showDispatchModal"
      @close-modal="showDispatchModal = false" :selcetdDispatchDetail="selcetdDispatchDetail"
      :dispatchSummary="dispatchSummary" :fleetId="fleetId" />

    <UpdateConsolidationStatusModal :showmodal="showUpdateStatusModal" @close-modal="showUpdateStatusModal = false"
      :selectedItem="selectedItem" @refetchBooking="refetchOverview" />

  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import Yes from './modules/Yes.vue';
import No from './modules/No.vue';
import ShippingLabel from "../Modals/ShippingLabel.vue";
import DispatchModal from "../Modals/DispatchModal.vue";
import UpdateConsolidationStatusModal from "../Modals/update-consolidation-status.vue";


export default {
  components: {
    Yes,
    No,
    PageHeader,
    ShippingLabel,
    DispatchModal,
    UpdateConsolidationStatusModal
  },

  data() {
    return {
      type: '',
      selecetedDispatch: [],
      selcetdDispatchDetail: [],
      showShippinLabel: false,
      showDispatchModal: false,
      showUpdateStatusModal: false,
      selected: 'Yes',
      longHaulDispatchables: [],
      selectedItem: null,
      dispatchSummary: null,
      fleetId: null
    };
  },

  methods: {
    refetchOverview() {
      this.setSelecetedDIspatch(this.selecetedDispatch)
    },
    goBack() {
      this.showShippinLabel = true;
    },
    createDispatch() {
      this.showDispatchModal = !this.showDispatchModal;
      this.getLongHaulSummary();
    },
    updateStatus(val) {
      this.selectedItem = val;
      this.showUpdateStatusModal = !this.showUpdateStatusModal;
    },

    setSelecetedDetailDIspatch(dispatchs) {
      this.selcetdDispatchDetail = dispatchs
    },
    setSelecetedDIspatch(dispatchs) {
      this.selecetedDispatch = dispatchs
      this.getConsolidatedItems({ type: this.type, consolidationId: this.selecetedDispatch[0] });
    },
    openDispatchModal() {
      this.showShippinLabel = false;
      this.showDispatchModal = true;
    },
      openDispatchSummaryAction() {
        this.showDispatchModal = true;
      },
   
    openShippingLabelAction() {
      this.showShippinLabel = true
    },
    selectOption(option) {
      this.selected = option;
    },
    selectTab(index) {
      this.selectedIndex = index;
    },
    async getConsolidatedItems(params) {
      try {
        this.loading = true;

        const response = await this.$_getDispatchableFleetOverview(params);
        this.longHaulDispatchables = response.data.data;

      
      } catch (error) {
        console.log(error);
      }
    },
    async getLongHaulSummary() {
      try {
        this.loading = true;
        const payload = {
          consolidationIds: this.selecetedDispatch
        };
        const { data: response } = await this.$_getDispatchSummary(payload);
        this.dispatchSummary = response.data
        this.fleetId = response.data.fleetInfo.id
        console.log("dispatchSummary", this.dispatchSummary);

      } catch (error) {
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    }
  },

};

</script>

<style lang="scss" scoped>
.business-status>:nth-child(1)>:nth-child(1) {
  width: 35%;
}

.color-box.active {
  background-color: #FFA600;
}

.color-box {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  border: 1px solid #C5C4D4;
  cursor: pointer;
}

.box-cover>p {
  color: #383F51;
  font-size: 14px;
  font-weight: 400;
}
</style>
